// extracted by mini-css-extract-plugin
export default {"background":"GuestLayout_background__O9zsG"};